import type { ZoneLoadState, ZoneLoadProgress } from "../app/zone-load-gate.js";
import { button } from "../design/components.js";

type T = (k: string, p?: Record<string, string | number>) => string;

/** "Checking your area…" plus, when known, what the work behind it is doing
 *  ("backlog 10/100" windows scanned, "attempt 3/5" seed retries). */
export function checkingLine(t: T, progress?: ZoneLoadProgress): HTMLElement {
  const p = document.createElement("p");
  p.className = "bx-body zone-checking";
  p.textContent = progress ? `${t("zone.checking")} ${progressText(t, progress)}` : t("zone.checking");
  return p;
}

export function progressText(t: T, progress: ZoneLoadProgress): string {
  const key = progress.kind === "windows" ? "zone.progress.windows" : "zone.progress.attempts";
  return t(key, { done: progress.done, total: progress.total });
}

/** "Can't reach the network yet — still trying…" for ZoneLoadGate `stalled`, with ONE Retry
 *  button when the caller can re-run the work (a single tap; the gate ignores repeats). */
export function stalledLine(t: T, onRetry?: () => void): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "zone-stalled";
  const p = document.createElement("p");
  p.className = "bx-body zone-checking";
  p.textContent = t("zone.stalled");
  wrap.append(p);
  if (onRetry) {
    // Design rule: an action button is always a design-system `button()` — primary (ink,
    // like the Talk send button) for the one thing to do here, secondary (outlined) otherwise.
    const btn = button({ label: t("zone.retry"), variant: "primary", onClick: () => { (btn as HTMLButtonElement).disabled = true; onRetry(); } });
    btn.setAttribute("data-action", "zone-retry");
    wrap.append(btn);
  }
  return wrap;
}

/** Resolve a tab's load state from the legacy boolean (`loaded`) and the new tri-state. */
export function loadStateOf(loadState: ZoneLoadState | undefined, loaded: boolean | undefined): ZoneLoadState {
  if (loadState) return loadState;
  return loaded === false ? "checking" : "loaded";
}
